import { Button, Row, Typography } from "antd";
import { Content } from "antd/es/layout/layout";
import styled from "styled-components";

const { Text } = Typography;

export const StyledBackButton = styled(Button)`
  &&.ant-btn-text {
    margin-top: 20px;
    height: 10px;
    display: flex;
    align-items: center;
    font-size: 16px;

    &:hover {
      background-color: white;
      border-color: white;
      /* color: #192238; */
    }
  }
`;

export const StyledText = styled(Text)`
  font-weight: 700;
  font-family: "Lato";
  font-size: 16px;
  color: #005461;
  /* margin-left: 35px; */
`;

export const StyledContent = styled(Content)`
  border-bottom: 0.5px solid lightgrey;
  margin-bottom: 10px;
  height: 60px;

  /* flex: 0.081; */

  @media (max-width: 1366px) {
    /* flex: 0.1; */
  }
`;

export const StyledButtonRow = styled(Row)`
  margin-top: 180px;
  @media (max-width: 1366px) {
    margin-top: 80px;
  }
`;

export const StyledPrimaryButton = styled(Button)`
  &&.ant-btn-primary {
    background-color: #b80000;
    font-size: 16px;
    width: 30%;
    height: 45px;
    margin-top: 10px;
    margin-bottom: 25px;
    border-radius: 50px;
    border-color: #b80000;
    color: white;
    /* border-radius: 0px; */
    font-family: "Lato";

    &:hover {
      background-color: white;
      border-color: #b80000;

      color: #b80000;
    }
    &:disabled {
      background-color: lightgray;
      border-color: lightgray;
      color: white;
    }
  }
`;

export const StyledPrimaryBackButton = styled(Button)`
  &&.ant-btn-primary {
    background-color: white;

    font-size: 16px;
    width: 30%;
    height: 45px;
    margin-top: 10px;
    margin-bottom: 25px;
    border-radius: 50px;
    border-color: black;
    color: black;
    /* border-radius: 0px; */
    font-family: "Lato";

    &:hover {
      background-color: black;
      border-color: black;

      color: white;
    }
    &:disabled {
      background-color: lightgray;
      border-color: lightgray;
      color: white;
    }
  }
`;

export const StyledModelSwitchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 0.5px solid lightgrey;
  background-color: #f8f9fa;
  
  .ant-switch {
    &.ant-switch-checked {
      background-color: #b80000;
    }
  }
`;